import { render } from "./BaseInputLabel.vue?vue&type=template&id=739e5978"
import script from "./BaseInputLabel.vue?vue&type=script&lang=js"
export * from "./BaseInputLabel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__